import React, { useEffect, useRef, useState } from 'react'
import styles from '../styles/vipTop.module.scss'
import { useAssetImage } from '@/platforms/utils'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

const VipTop = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('vip')

  const icon1 = useAssetImage('vip-icon-top1',{theme: true})
  const icon2 = useAssetImage('vip-icon-top2',{theme: true})
  const icon3 = useAssetImage('vip-icon-top3',{theme: true})
  const items = [
    {
      icon: icon1,
      Title: t('vipTop.levelAndRewards'),
      Content: t('vipTop.levelUpExperience')
    },
    {
      icon: icon2,
      Title: t('vipTop.increaseCashback'),
      Content: t('vipTop.boostedCashback')
    },
    {
      icon: icon3,
      Title: t('vipTop.exclusiveOffers'),
      Content: t('vipTop.exclusivePromotions')
    }
  ]


  return (
    <div className={styles.vip_top}>
      <div className={styles.left}>
        <div>{t('vipTop.vipClub')}</div>
        <div>{t('vipTop.vipJoinReward')}</div>
        <div onClick={() => {navigate('/vip/details')}}>
          <button>{t('vipTop.viewVipDetails')}</button>
        </div>
      </div>

      <div className={styles.right}>
        {items.map((v,index)=>(
            <div key={index}>
              <img src={v.icon} alt="" />
              <div className={styles.text}>
                <div>{v.Title}</div>
                <div>{v.Content}</div>
              </div>
            </div>
        ))}
      </div>
    </div>  
  )
}

export default VipTop
